module.exports = __webpack_public_path__ + "static/PatKT-06-110b2746a9a927daa456520b495580fd.jpg";